import { Box } from "@mui/material";
import type { FormSelectOption } from "@zfp-akademie-a-s/zfp-design/form";
import { HtmlParser } from "Components/_Shared/HtmlParser";
import type { CodeListItem } from "Infrastructure/Models/ICodeListDto";
import { Spacing } from "Infrastructure/Themes/Themes";

export type Option = {
  readonly value: string;
  readonly name: string;
  readonly hidden?: boolean;
};

// option names may carry <b> and <br> from the API
export const toSelectOptions = (options: Option[]): FormSelectOption<string>[] =>
  options.map(({ value, name, hidden }) => ({ value, label: <HtmlParser content={name} />, hidden }));

export const toRadioOptions = (codeList: CodeListItem[]) =>
  codeList.map(({ code, name, description, endAdornment }) => ({
    value: String(code),
    label: endAdornment ? (
      <>
        {name}
        <Box component="span" ml={Spacing.XS}>
          {endAdornment}
        </Box>
      </>
    ) : (
      name
    ),
    description,
  }));
